export default "__VITE_ASSET__CpGSIy$h__"